import { ApiError } from '../api/client.js';

/**
 * Map a VALIDATION_ERROR response onto react-hook-form via setError.
 * Returns true when at least one field error was applied so callers
 * can suppress a generic toast in that case.
 */
export function applyServerValidation(err, setError, knownFields = []) {
  if (!(err instanceof ApiError) || err.code !== 'VALIDATION_ERROR' || !Array.isArray(err.details)) {
    return false;
  }
  let applied = false;
  for (const d of err.details) {
    const field = Array.isArray(d.path) ? d.path.join('.') : d.path;
    if (knownFields.length && !knownFields.includes(field)) continue;
    setError(field, { type: 'server', message: d.message });
    applied = true;
  }
  return applied;
}
